import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-paidan-h",
  "use": "icon-paidan-h-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" id=\"icon-paidan-h\">\n  <path d=\"M16 3h5v5\" />\n  <path d=\"M8 3H3v5\" />\n  <path d=\"M21 3l-7.5 7.5\" />\n  <path d=\"M3 3l7.5 7.5\" />\n  <path d=\"M3 21l7.5-7.5\" />\n  <path d=\"M21 21l-7.5-7.5\" />\n  <circle cx=\"12\" cy=\"12\" r=\"3\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/paidan-h.svg
// module id = ZpRw
// module chunks = 96